'use client';
import { SkuTier } from '../../types/order.js';

const humanizeTier = (tier) => {
    switch (tier) {
        case SkuTier.BASE:
            return 'Standard';
        case SkuTier.PRO:
            return 'Advanced';
        case SkuTier.ELITE:
            return 'Elite';
        case SkuTier.ELITE_PLUS:
            return 'Elite+';
    }
};

export { humanizeTier };
//# sourceMappingURL=humanize-tier.js.map
